import styled from "styled-components";
import { STYLED_CONSTANTS } from "./constant";

export const ButtonContainer = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.small,
    width: "100%",
    marginTop: theme.spacing.xLarge,
    paddingBottom: `calc(var(--sab, 0px) + ${STYLED_CONSTANTS.BUTTON_CONTAINER_PADDING_BOTTOM})`,
}));

export const FlexCta = styled.div({
    flex: "1 1 0",
});

export const HeadingTitleContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.large,
    width: STYLED_CONSTANTS.HEADING_TITLE_CONTAINER_WIDTH,
}));

export const DescriptionContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.small,
    width: STYLED_CONSTANTS.DESCRIPTION_CONTAINER_WIDTH,
}));
